import { orderXClient } from '@/service/client'
import type {
  CreateSharedLayoutRequest,
  CreateSharedLayoutResponse,
  GetSharedLayoutResponse,
  ServerMessage,
} from '@/types/generated/public_api'

export async function createSharedLayout(
  req: CreateSharedLayoutRequest
): Promise<CreateSharedLayoutResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', { createSharedLayout: req })
  return data.createSharedLayoutResponse!
}

// The endpoint takes no auth: the share id is the whole credential. Today every
// caller is signed in — /sl/<shareId> sends a logged-out visitor through /login
// first, because the share opens as a real trade page and that needs a session —
// but the read itself stays anonymous so a share can be opened from anywhere the
// product later wants to. The client's request interceptor attaches a token only
// when one already exists, so this works either way without a separate axios
// instance.
export async function getSharedLayout(shareId: string): Promise<GetSharedLayoutResponse> {
  const { data } = await orderXClient.post<ServerMessage>('/api', {
    getSharedLayout: { shareId },
  })
  return data.getSharedLayoutResponse!
}
